// @file Surface remake panel store
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSurfaceRemakePanelStore = defineStore('surfaceRemakePanel', () => {
  /* ---------------------- */
  /* STATE                  */
  /* ---------------------- */

  const xRemakePanel = ref<boolean>(false)

  /* ---------------------- */
  /* ACTIONS                */
  /* ---------------------- */
  const showRemakePanel = (): void => {
    xRemakePanel.value = true
  }

  const closeRemakePanel = (): void => {
    xRemakePanel.value = false
  }

  return {
    xRemakePanel,
    showRemakePanel,
    closeRemakePanel,
  }
})
